window.fnOpenSystemAbout = function ()
{
	Q.fnOpenModal({sUrl:'/about/popup', sTitle:'О системе', iWidth:540, iHeight:320});
}

window.fnOpenPerson = function (id, rel)
{
	// Раньше мы учитывали rel, но теперь в этом нет необходимости.

	if(empty(id)) Q.fnAlert("Данный человек не является сотрудником предприятия. На него нельзя посмотреть карточку.");

	QForm.fnOpenView("personcard", id);
}

$("#topMenu a.brand").click(function(e)
{
	if(e.altKey)
	{
		document.location.href="/";
		e.stopPropagation();
		e.preventDefault();
		e.stopImmediatePropagation();
		return false;
	}
});

window.fnUpdateAllDataTables = function (oReloadSettings)
{
	if(!oReloadSettings)
		oReloadSettings = {callback: null, resetPaging: true};

	var $aTables = $("table.dataTable:not(.floatThead-table)");
	if($aTables.length) $aTables.each(function(){
		var oQList = $(this).data("q-data-table");
		if(!empty(oQList)) oQList.fnAutoSize(true, oReloadSettings);
	});
}

$("body").on("click", "span.undercut + span.cut", function(e)
{
	//alert("...");
	$(e.target).prev().toggleClass("opened");
	e.preventDefault();
	e.stopPropagation();
	e.stopImmediatePropagation();
});

